<template>
    <div class="container mt-5">
        <loading :loading="loading" text="Connecting..."/>
    </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import Loading from "@/shared/components/common/Loading.vue";
import { Global } from "@/support/GlobalData";

export default defineComponent({
    components: {
        Loading,
    },
    data() {
        return {
            loading: false,
        };
    },
    mounted(): void {
        this.loading = true;
        Global.MainApp.connectSession((): void => {
            // no action
        });
    },
});

</script>
